import axios from "axios";
import { AUTH_API_URL } from "config";

import { getToken } from "utils/utility";

const UserService = axios.create({
  baseURL: AUTH_API_URL,
  withCredentials: true
});

UserService.interceptors.request.use(
  (config) => {
    const token = getToken();

    if (token)
      config.headers.Authorization = `Token ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

UserService.interceptors.response.use(
  (response) => {
    // return response.data
    return response;
  },
  (error) => {
    if (error && error?.response?.status === 403) {
      // Cookies.remove("lmos-token");
      window.location.pathname = "/";
    }
    if (error && error.response && error.response.status === 401) {
      // Cookies.remove("lmos-token");
    }

    // Notify.error(error, true);
    return Promise.reject(error);
  }
);

export { UserService };

